import React from 'react'
import { Modal, Row, Col, Button, Space, Flex, Typography, Image } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
const { Text, Title } = Typography
const FaqView = ({ view, onClose }) => {
    return (
        <div>
            <Modal
                width={600}
                title={null}
                className='shadow-c modal-cs'
                open={view}
                onOk={onClose}
                onCancel={onClose}
                closeIcon={false}
                centered
                footer={
                    <Space style={{ justifyContent: "end" }} className="w-100">
                        <Button
                            onClick={onClose}
                            block
                            type="primary"
                            className='btnsave text-white'
                        >
                            Cancel
                        </Button>
                    </Space>
                }
            >
                <Flex align='center' justify='space-between' className='header-modal'>
                    <Title level={5} className='m-0'>Faq Details</Title>
                    <Button className='bg-transparent border0 p-0 ' onClick={onClose}>
                        <CloseOutlined className='text-gray' />
                    </Button>
                </Flex>
                <div
                    className='content-modal pb-2'
                >
                    <Row gutter={[24, 24]} justify={'center'}>
                        <Col span={24}>
                            <Space direction='vertical' size={5}>
                                <Text strong className='fs-14'>Faq Title :</Text>
                                <Text className='fs-14'>{view?.title}</Text>
                            </Space>
                        </Col>
                        <Col span={24}>
                            <Space direction='vertical' size={5}>
                                <Text strong className='fs-14'>Faq Description :</Text>
                                <Text className='fs-14'>{view?.description}</Text>
                            </Space>
                        </Col>
                    </Row>
                </div>
            </Modal>
        </div>
    )
}

export { FaqView }